(() => {
  const tablet = window.matchMedia('(min-width: 750px) and (max-width: 1199px)');

  function syncShortCollectionPromo(root) {
    if (!root || root.classList.contains('main-collection--catalog')) return;

    const grid = root.querySelector('#EcwPlpGridProducts');
    if (!grid) return;

    const inserted = grid.querySelector('[data-yx-compact-short-promo]');
    if (!tablet.matches) {
      inserted?.remove();
      return;
    }

    const realSlots = Array.from(grid.children).filter((item) =>
      !item.matches('.main-collection__empty, [data-yx-compact-short-promo]'),
    );

    if (realSlots.length === 0 || realSlots.length >= 6 || inserted) return;

    const pageRoot = root.closest('main') || document;
    const sourcePromo = pageRoot.querySelector(
      '.main-collection__list--after-promo .yx-collection__grid-promo',
    );
    const sourceSlot = sourcePromo?.closest('li');
    if (!sourceSlot) return;

    const shortPromo = sourceSlot.cloneNode(true);
    shortPromo.setAttribute('data-yx-compact-short-promo', '');
    grid.append(shortPromo);
  }

  function syncAllShortCollectionPromos() {
    document.querySelectorAll('.main-collection[data-yx-page-mode="listing"]').forEach(syncShortCollectionPromo);
  }

  let frame;
  function queueSync() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = undefined;
      syncAllShortCollectionPromos();
    });
  }

  tablet.addEventListener('change', queueSync);
  window.addEventListener('pageshow', queueSync);
  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
  queueSync();
})();
